import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../components/global/Button';
import ArrowRight from '../../../../../components/icons/ArrowRight';
import PhoneInput from '../../../../../components/global/PhoneInput';
import CustomControl from '../../../../../components/global/CustomControl';

const propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    phone_number: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onLoginViaEmail: PropTypes.func,
  requireHumanInput: PropTypes.bool,
  blockLogin: PropTypes.bool,
};

const PhoneForm = ({
  values,
  handleSubmit,
  handleChange,
  loading,
  onLoginViaEmail,
  requireHumanInput,
  blockLogin,
}) => {
  return (
    <Fragment>
      <h4 className="text-center mb-2">
        Enter your mobile number and I&apos;ll <br />
        send you all your photos!{' '}
      </h4>
      <form
        onSubmit={handleSubmit}
        className="w-100 px-0 px-md-6 d-flex flex-column align-items-center"
      >
        <PhoneInput
          id="phone_number"
          label=""
          value={values.phone_number || '+1'}
          onChange={phone =>
            handleChange({
              target: {
                name: 'phone_number',
                value: phone,
              },
            })
          }
          className="w-100 mb-0"
          autoFocus
        />
        {requireHumanInput && (
          <div className="w-100 mt-2 mb-1">
            <CustomControl
              type="checkbox"
              label="I'm not a robot"
              checked={values.force_allow_action}
              onChange={() =>
                handleChange({
                  target: {
                    name: 'force_allow_action',
                    value: !values.force_allow_action,
                  },
                })
              }
            />
          </div>
        )}
        <Button
          type="submit"
          className="mt-2 mb-4"
          btnBlock
          disabled={
            loading ||
            values.phone_number === '+1' ||
            blockLogin ||
            (requireHumanInput && !values.force_allow_action)
          }
        >
          {loading ? 'Sending...' : 'Send PIN Code'}
        </Button>
      </form>
      <p className="text-center mb-0">
        By continuing you agree to the{' '}
        <a href="/terms" target="_blank" rel="noopener noreferrer">
          Terms of Use
        </a>
        .
      </p>
      <p className="text-center mb-0">This site is protected by reCAPTCHA.</p>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">
        Can&apos;t receive a US SMS message?{' '}
        <Button
          btnStyle="reset"
          className="ml-0 ml-md-2 mt-1 mt-md-0 d-flex align-items-center text-primary text-extra-bold"
          onClick={() => onLoginViaEmail()}
        >
          Use email instead{' '}
          <ArrowRight color="#0d84fe" className="ml-1" size={15} />
        </Button>{' '}
      </div>
    </Fragment>
  );
};

PhoneForm.propTypes = propTypes;

export default PhoneForm;
